import { Header } from '@tanstack/react-table';
import styled from 'styled-components';
import UnsortedIcon from '@paradigm/design-system/src/assets/UnsortedIcon';
import SortAscIcon from '@paradigm/design-system/src/assets/SortAscIcon';
import SortDescIcon from '@paradigm/design-system/src/assets/SortDescIcon';
import { paradigmLightBlue } from '@paradigm/design-system/src/colors';

export default function SorterComponent<T>({
  header,
}: {
  header: Header<T, unknown>;
}) {
  return (
    <Sorter
      hidden={header.column.columnDef.enableSorting === false}
      onClick={header.column.getToggleSortingHandler()}
      data-testid={`${header.column.id}-sorter`}
    >
      {header.column.getIsSorted() !== false ? (
        {
          asc: <SortAscIcon />,
          desc: <SortDescIcon />,
          default: <UnsortedIcon />,
        }[
          header.column.getIsSorted().valueOf() === false ||
          header.column.getIsSorted().valueOf() === true
            ? 'default'
            : header.column.getIsSorted().valueOf().toString()
        ]
      ) : header.column.getCanSort() ? (
        <UnsortedIcon />
      ) : (
        ''
      )}
    </Sorter>
  );
}

const Sorter = styled.div`
  display: flex;
  cursor: pointer;
  color: ${paradigmLightBlue};
`;
